import { render } from "./TheSelect2.vue?vue&type=template&id=35129aa2"
import script from "./TheSelect2.vue?vue&type=script&lang=js"
export * from "./TheSelect2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__